hashType